import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=0b4fa341"
import script from "./NameInput.vue?vue&type=script&lang=js"
export * from "./NameInput.vue?vue&type=script&lang=js"
import style0 from "./NameInput.vue?vue&type=style&index=0&id=0b4fa341&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports